var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"direction":"horizontal"}},[_c('el-aside',{attrs:{"width":""}},[_c('TheSidebar')],1),_c('el-container',[_c('el-header',[_c('TheHeader')],1),_c('el-main',[_c('router-view'),_c('el-backtop')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }